module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_aqua-c7ef1a59b2080026452d69c95c582273.webp";